import mustache from "mustache";
import { serviceProvider } from "../../../comun/provider/ServiceProvider";
import { BaseCreateRender } from "../../base/BaseCreateRender";
import { ConfirmModalConfig } from "../../definitions/modal/ConfirmModalConfig";
import template from "./confirmModalTemplate.html";

mustache.parse(template);

/** Modal chico de confirmación (auto-montado sobre `body`): título, mensaje y
 *  botones Cancelar / confirmar (danger). Al confirmar deshabilita el botón,
 *  ejecuta `onConfirm` y se cierra al éxito (los errores van al errorService y
 *  el modal queda abierto). Cancela por botón o click en el backdrop. */
export class ConfirmModalRender extends BaseCreateRender {
  /** Id del elemento raíz auto-montado en `body`. */
  protected readonly elementId = "confirmModal";

  constructor(private readonly _config: ConfirmModalConfig) {
    super();
  }

  /** HTML del modal: overlay + card con título/mensaje/acciones. */
  protected getHtml(): string {
    return mustache.render(template, {
      title: this._config.title,
      message: this._config.message,
      confirmLabel: this._config.confirmLabel ?? "Eliminar",
    });
  }

  /** Captura overlay/botones, cablea acciones y anima la apertura. */
  protected afterInit(element: HTMLDivElement): void {
    this._overlay = element.querySelector<HTMLDivElement>(".sx-modal-overlay");
    this._cancelBtn = element.querySelector<HTMLButtonElement>(
      '[data-act="cancel"]',
    );
    this._confirmBtn = element.querySelector<HTMLButtonElement>(
      '[data-act="confirm"]',
    );
    this._overlay?.addEventListener("click", this._onOverlayClick);
    this._cancelBtn?.addEventListener("click", this._onCancel);
    this._confirmBtn?.addEventListener("click", this._onConfirm);
    requestAnimationFrame(() =>
      this._overlay?.classList.add("sx-modal-overlay--open"),
    );
  }

  /** Libera los listeners antes de desmontar el modal. */
  protected beforeDispose(_element: HTMLDivElement): void {
    this._overlay?.removeEventListener("click", this._onOverlayClick);
    this._cancelBtn?.removeEventListener("click", this._onCancel);
    this._confirmBtn?.removeEventListener("click", this._onConfirm);
  }

  private _overlay: HTMLDivElement | null = null;
  private _cancelBtn: HTMLButtonElement | null = null;
  private _confirmBtn: HTMLButtonElement | null = null;

  /** Cierra el modal solo si el click fue en el backdrop (no en el contenido). */
  private _onOverlayClick = (e: MouseEvent): void => {
    if (e.target !== this._overlay) return;
    this._config.onCancel?.();
    this.dispose();
  };

  private _onCancel = (): void => {
    this._config.onCancel?.();
    this.dispose();
  };

  /** Deshabilita el botón, ejecuta la acción y cierra al éxito. */
  private _onConfirm = (): void => {
    if (!this._confirmBtn) return;
    this._confirmBtn.disabled = true;
    this._config
      .onConfirm()
      .then(() => this.dispose())
      .catch((error) => {
        serviceProvider.getErrorService().addError("Error al eliminar", error);
        if (this._confirmBtn) this._confirmBtn.disabled = false;
      });
  };
}
